import * as React from "react";
export const ParceiroParametroBottom = () => {
  return (
    <React.Fragment>
      <div></div>
    </React.Fragment>
  );
};
